// src/components/popups/StoryMenuDrawer.js
import React from 'react';
import './StoryMenuDrawer.css';

import deleteIcon from '../../assets/delete-outline-icon.png';

export default function StoryMenuDrawer({
  isOpen,
  onClose,
  canDelete = true,
  onDelete,
}) {
  if (!isOpen) return null;

  const handleBackdrop = () => {
    // tap outside closes
    onClose?.();
  };

  const stop = (e) => e.stopPropagation();

  return (
    <div className="drawer-backdrop" onClick={handleBackdrop}>
      <div className="drawer-sheet" onClick={stop} role="dialog" aria-modal="true">
        <div className="drawer-grabber" aria-hidden />

        {canDelete ? (
          <button
            type="button"
            className="drawer-row danger"
            onClick={() => {
              onClose?.();
              onDelete?.(); // this will open the confirm delete drawer you already have
            }}
          >
            <img src={deleteIcon} alt="" className="drawer-row-icon" />
            <span>Delete story</span>
          </button>
        ) : (
          <button
            type="button"
            className="drawer-row disabled"
            disabled
            title="Legacy multi-item story; deletion would remove all its slides."
          >
            <img src={deleteIcon} alt="" className="drawer-row-icon" />
            <span>Delete (disabled)</span>
          </button>
        )}
      </div>
    </div>
  );
}
